<template>
  <div class="quote__part">
    <BlockLoader :loading="loading" />
    <div class="row">
      <div class="d-flex align-items-center justify-content-between">
        <h3>{{ title }}</h3>
        <button
          v-if="isEditable"
          v-access:[permissions]="{
            access: access,
            code: accessCode,
          }"
          v-tooltip="{ title: actionTitle }"
          class="btn btn-icon"
          @click="edit"
        >
          <FontAwesomeIcon :icon="'fa-light fa-' + actionIcon" />
        </button>
      </div>
      <template v-if="data && Object.keys(data).length && !data.hasError">
        <template v-for="(field, key) in data" :key="key">
          <RegistrationQuoteCellBlockComponent :field="field" />
        </template>
      </template>
      <div v-else class="col-12 col-md3">
        <AlertBlock
          :text="data && data.hasError ? data.hasError : $t('global.empty.no_data_available')"
          type="primary"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { dateFormatter } from "@/services/utilities/date-formatter";
import AlertBlock from "@/components/blocks/AlertBlock.vue";
import RegistrationQuoteCellBlockComponent from "@/components/registration/quote/cell/RegistrationQuoteCellComponent.vue";
import BlockLoader from "@/components/blocks/BlockLoader.vue";

export default {
  name: "RegistrationQuoteBlockComponent",
  components: { BlockLoader, RegistrationQuoteCellBlockComponent, AlertBlock },
  props: {
    data: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    isEditable: {
      type: Boolean,
      required: false,
      default: false,
    },
    actionTitle: {
      type: String,
      required: false,
      default: "",
    },
    actionIcon: {
      type: String,
      required: false,
      default: "",
    },
    action: {
      type: String,
      required: false,
      default: "",
    },
    access: {
      type: String,
      required: false,
      default: "",
    },
    accessCode: {
      type: String,
      required: false,
      default: "",
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    isDate(value) {
      return dateFormatter.isDate(value, this.locale);
    },
    formatDate(date) {
      return dateFormatter.format(date, "short");
    },
    edit() {
      this.$emit("edit", this.action);
    },
  },
};
</script>

<style lang="scss" scoped>
.quote {
  h3 {
    color: var(--primary-color);
    margin: 15px 0;

    @include dark-theme {
      color: $white;
    }
  }

  &__part {
    position: relative;
    border-bottom: 1px dashed $m_color_6;
    margin-bottom: 15px;
    padding-bottom: 15px;
  }
}

.item {
  &__title {
    font-weight: 500;
  }

  &__block {
    margin-bottom: 20px;
  }
}
</style>
